
import RefactoredSignupForm from "@/components/RefactoredSignupForm";

const Index = () => {
  return <RefactoredSignupForm />;
};

export default Index;
